import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import { fixHTMLContent, tryFn } from "../utils/utils"

export default ({data}) => {
    const post = data.page
    const content = tryFn(() => post.body.value)
    const title = tryFn(() => post.title)
    const desc = tryFn(() => post.field_metatags.description) || ''
    const slug = tryFn(() => post.fields.slug)

    let html = fixHTMLContent(content)
    if (slug === '/prostate-101/benign-prostate-disease/') {
        html = html.replace(/<form[\s\S]*?TULSA\s*Procedure\s*Request[\s\S]*?<\/form>/gi, '')
        html = html.replace(/<h2[^>]*>\s*We\s*Want\s*To\s*Hear\s*From\s*You\s*<\/h2>/gi, '')
        html = html.replace(/<h2[^>]*>\s*TULSA\s*Procedure\s*<\/h2>/gi, '')
        html = html.replace(/<p[^>]*>\s*TULSA\s*Procedure\s*Phone[\s\S]*?<\/p>/gi, '')
        html = html.replace(/<p[^>]*>\s*TULSA\s*Procedure\s*Fax[\s\S]*?<\/p>/gi, '')
        html = html.replace(/<div[^>]*class=\"[^\"]*hearfromyou[^\"]*\"[\s\S]*?<\/div>/gi, '')
    }
    return (
        <Layout page={title} desc={desc}>
        <div className="inside-page pt6 mb7">
            <div className="container-xs container-m container-inner clearfix">
                <h1 className="tc mb4-l">{post.title}</h1>
                <div className="mt3 mt5-l basic-page" dangerouslySetInnerHTML={{__html: html }}></div>
            </div>
         </div>
        </Layout>
    )
}

export const query = graphql`
    query($slug: String!) {
        page: nodePage(fields: { slug: { eq: $slug }}) {
            title
            body {
                value
            }
            field_metatags {
              title
              description
            }
            fields {
                slug
            }
        }
    }
`
